"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cMock = void 0;
const cMock = (data, time = 1000, success = true) => {
    return new Promise((resolve) => {
        setTimeout(() => resolve({
            data,
            success: success,
            messages: [
                success ? "عملیات با موفقیت انجام شد" : "عملیات با خطا مواجه شد",
            ],
        }), time);
    });
};
exports.cMock = cMock;
